import React from "react";
import { SvgIcon } from "@mui/material";

const ExportIcon = ({ fill }) => {
  return (
    <SvgIcon>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill={"none"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.7666 5.41666L9.89994 3.28333L12.0333 5.41666"
          stroke={fill || "white"}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.8999 11.8167V3.34167"
          stroke={fill || "white"}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.3335 10C3.3335 13.6833 5.8335 16.6667 10.0002 16.6667C14.1668 16.6667 16.6668 13.6833 16.6668 10"
          stroke={fill || "white"}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};
export default ExportIcon;
